// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__Y73M+","header":"Projects_header__TzMMY","backButton":"Projects_backButton__upJ2E"};